import React, { useId } from 'react';
import classNames from 'classnames';
import { ErrorMessage, useFormikContext } from 'formik';
const Select = ({ helpText, iconLeft, iconRight, label, name, options, placeholder, 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
value, ...props }) => {
    const uniqueId = useId();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { errors, touched } = useFormikContext();
    const hasError = errors[name] && touched[name];
    return (React.createElement("div", { className: 'form-element-select' },
        label && (React.createElement("label", { className: 'form-element-label', htmlFor: name + '_' + uniqueId }, label)),
        React.createElement("div", { className: classNames('form-element-container', { 'has-error': hasError }) },
            iconLeft && React.createElement("div", { className: 'icon' }, iconLeft),
            React.createElement("select", { name: name, id: name + '_' + uniqueId, ...props, defaultValue: value === '' && placeholder ? '' : undefined, value: value },
                placeholder && (React.createElement("option", { value: '', disabled: true }, placeholder)),
                options &&
                    options.map(option => (React.createElement("option", { key: option.value, value: option.value }, option.label)))),
            iconRight && React.createElement("div", { className: 'icon' }, iconRight)),
        helpText && React.createElement("p", { className: 'form-elements-help-text' }, helpText),
        hasError && (React.createElement("p", { className: 'form-elements-error-message' },
            React.createElement(ErrorMessage, { name: name })))));
};
export default Select;
